export default {
  menu: 'Cashes',
  title: 'Cashes',

  general: {
    labels: {
      name: 'Name',
      delete: 'Delete',
      shop: 'Shop'
    },

    confirmations: {
      emptyCash: {
        title: 'No cash available',
        body: 'To create {name}, you need to connect a cash. Please create one first.'
      },
      delete: {
        title: 'Confirm Delete Cash',
        body: 'Are you sure you want to temporarily delete {cashBox} cash?'
      },
      forceDelete: {
        title: 'Confirm Delete Cash',
        body: 'Are you sure you want to delete {cashBox} cash permanently?'
      }
    },

    notifications: {
      insert: {
        success: 'New cash info successfully created',
        error: 'Registering new cash information failed'
      },

      edit: {
        success: 'Cash info successfully updated',
        error: 'Updating new cash information failed'
      },

      delete: {
        success: 'Cash info successfully deleted',
        error: 'Deleting new cash information failed'
      },

      restore: {
        success: 'Cash info successfully restored',
        error: 'Restoring new cash information failed'
      }
    },

    table: {
      header: {
        select: 'Select',
        row: 'Row',
        name: 'Name',
        balance: 'Inventory',
        delete: 'Delete',
        restore: 'Restore'
      }
    }
  },

  list: {
    title: 'Cashes'
  },

  trash: {
    title: 'Trashed Cashes'
  },

  insert: {
    title: 'Insert New Cash'
  },

  edit: {
    title: 'Edit Cash',
    dynamicTitle: 'Edit Box {cashBox}'
  },

  cashBox: {
    title: 'Cash',
    dynamicTitle: '{cashBox} Cash',

    importantData: {
      balance: 'Inventory',
      openingBalance: 'Opening balance',
      transactionsCount: 'Number of Transactions'
    },

    actions: {
      transactions: 'Cash Turnover',
      logs: 'Time lines'
    }
  },

  transactions: {
    title: 'Cash Turnover',
    dynamicTitle: '{cashBox} Cash Turnover',

    table: {
      header: {
        balance: 'Inventory',
        price: 'Amount',
        description: 'Documents',
        date: 'Date',
        docNumber: 'Document Number'
      }
    }
  },

  logs: {
    title: 'Cash logs'
  },

  openingBalance: {
    general: {
      labels: {
        price: 'Amount',
        delete: 'Delete Opening Balance'
      },

      confirmations: {
        delete: {
          title: 'Delete Confirmation',
          body: 'Are you sure you want to delete the cash opening balance?'
        }
      },

      notifications: {
        locked: 'opening balance is the lock',
        negativeBalance: 'Cash cant get negative balance',

        isExisted: {
          message: 'This value is in the list',
          dynamicMessage: 'Box {cashBox} is in the list'
        },

        insert: {
          success: 'The opening balance of the fund in question was successfully registered',
          error: 'The registration of the desired fund opening balance was accompanied by an error'
        },

        edit: {
          success: 'The opening balance of the fund was successfully updated',
          error: 'The first update of the box in question was accompanied by an error'
        },

        delete: {
          success: 'The first fund in question was successfully deleted',
          error: 'The first deletion of the box in question was accompanied by an error'
        }
      },

      table: {
        header: {
          delete: 'Delete',
          price: 'Amount',
          name: 'Fund Name',
          row: 'Row'
        }
      }
    },

    insert: {
      title: 'Add the first fund course'
    },

    edit: {
      title: 'The first edition of the fund period {cashBox}'
    }
  }
}
